import React from "react";
import { FiArrowLeft } from "react-icons/fi";
// @ts-ignore
import { ThreeDots } from "react-loader-spinner";

import Typography from "@/components/Typography";

import { Container } from "./styles";
import { SimpleButtonProps } from "./types";

const SimpleButton = ({
  variant = "cta",
  status = "enable",
  label,
  backgroundColor,
  onClick,
  className,
  title,
  icon,
  iconLeft,
}: SimpleButtonProps) => {
  const leftIcon = iconLeft || icon || (variant === "back" ? <FiArrowLeft /> : null);

  return (
    <Container
      disabled={status == "loading" || status == "disabled" ? true : false}
      variant={variant}
      status={status}
      label={typeof label === "string" ? label : ""}
      onClick={onClick}
      $backgroundColor={backgroundColor}
      className={className}
      title={title}
    >
      {leftIcon && <div className="icon-left">{leftIcon}</div>}
      {label ? (
        <div className="info-button">
          {status != "loading" ? (
            <Typography
              color={backgroundColor ? "black" : status == "disabled" ? "grey500" : "white"}
              variant="btnLarge"
            >
              {label}
            </Typography>
          ) : (
            <div className="loading-size">
              <ThreeDots color="white" />
            </div>
          )}
        </div>
      ) : status == "loading" ? (
        <div className="loading-size">
          <ThreeDots color="white" />
        </div>
      ) : null}
    </Container>
  );
};

export default SimpleButton;
